export const MAX_CIRCLE_SIZE = 362;
